import { ANALYTICS_EVENTS } from "@/lib/analytics/catalog";

export type EventName =
  (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS];

export type UiEventName = Extract<EventName, `ui_${string}`>;
export type FlowEventName =
  | Extract<EventName, `flow_${string}`>
  | "service_visit_client";
export type ResultEventName = Extract<EventName, `result_${string}`>;

export type EventPropsMap = {
  [K in EventName]: Record<string, unknown>;
};

export type BaseEventProps = {
  env: string;
  environment: string;
  app: "aseed-client";
  platform: "web";
  source: "frontend";
  source_service: "aseed-client";
  route: string;
  build_version: string;
  session_id: string;
};

export const UPLOAD_SOURCES = [
  "records_page_upload_header",
  "project_detail_upload_header",
  "project_detail_upload_empty_state",
  "create_project_modal_add_files_header",
  "create_project_modal_dropzone_click",
  "create_project_modal_dropzone_drop",
  "create_project_background_upload",
  "unknown",
] as const;

export type UploadSource = (typeof UPLOAD_SOURCES)[number];

export const UPLOAD_ERROR_CODES = [
  "unsupported_file_type",
  "file_too_small",
  "file_too_large",
  "not_enough_space",
  "auth_required",
  "network_error",
  "upload_aborted",
  "record_create_failed",
  "backend_validation_failed",
  "transcript_update_failed",
  "report_save_failed",
  "unknown_error",
] as const;

export type UploadErrorCode = (typeof UPLOAD_ERROR_CODES)[number];

export const TRANSCRIPT_VALIDATION_REASONS = [
  "missing_name",
  "missing_content",
  "content_too_large",
  "utterances_none",
  "utterances_too_few",
  "utterances_too_many",
  "duration_too_short",
  "duration_too_long",
  "parser_mismatch",
  "unknown_validation_error",
] as const;

export type TranscriptValidationReason =
  (typeof TRANSCRIPT_VALIDATION_REASONS)[number];
